import { getCommercial, postCommercial } from "../.";
import { LanguageBackendType } from "../../../pages/shared/components/language/types";
import {
  BasicAccountApplicationDocument,
  BasicAccountApplicationDto,
  BasicAccountBenefitsDto,
  CancelApplicationDto,
  ChangeApplicationProductDto,
  CompanyBasicDataDto,
  CompanyOnlineDto,
  CustomizationLinkDocument,
  GeneralCompanyInformationDto,
  PowerOfAttorneyDto,
  RegulatoryInfoDto,
} from "../generated-types";

const create = async (request: BasicAccountApplicationDto): Promise<string> => {
  return postCommercial("/protected/application/basic-account", request);
};

const createGeneralCompanyInformation = async (
  request: GeneralCompanyInformationDto,
): Promise<void> => {
  return postCommercial("/protected/application/basic-account/gci", request);
};

const createPowerOfAttorney = async (
  request: PowerOfAttorneyDto,
): Promise<void> => {
  return postCommercial(
    "/protected/application/basic-account/power-of-attorney",
    request,
  );
};

const updateCompanyOnline = async (
  request: CompanyOnlineDto,
): Promise<void> => {
  return postCommercial(
    "/protected/application/basic-account/company-online",
    request,
  );
};

const query = (
  applicationRef: string,
): Promise<BasicAccountApplicationDocument> => {
  return getCommercial("/protected/application/basic-account", {
    applicationRef,
  });
};

const updateCompanyInformation = async (
  request: CompanyBasicDataDto,
): Promise<void> => {
  if (request.basicAccountApplicationRef) {
    return postCommercial(
      "/protected/application/basic-account/company",
      request,
    );
  }
};

const updateRegulatoryInfo = async (
  request: RegulatoryInfoDto,
): Promise<void> => {
  return postCommercial(
    "/protected/application/basic-account/regulatory-info",
    request,
  );
};

const requestBasicAccountBenefits = async (
  request: BasicAccountBenefitsDto,
): Promise<void> => {
  return postCommercial(
    "/protected/application/basic-account/benefits",
    request,
  );
};

const cancel = async (
  baaRef: string,
  request: CancelApplicationDto,
): Promise<void> => {
  return postCommercial(
    `/protected/application/basic-account/${baaRef}/cancel`,
    request,
  );
};

const changeProduct = async (
  baaRef: string,
  request: ChangeApplicationProductDto,
): Promise<void> => {
  return postCommercial(
    `/protected/application/basic-account/${baaRef}/change-product`,
    request,
  );
};

/**
 * This function gets the link for the customization of card.
 *
 * @param baaRef The application ref of the basic account.
 * @param language The frontend language.
 */
const retrieveImageServiceLink = (
  baaRef: BasicAccountApplicationDocument["applicationRef"],
  language: LanguageBackendType,
): Promise<CustomizationLinkDocument> => {
  return getCommercial(
    `/protected/application/basic-account/${baaRef}/image-service-link/${language}`,
  )
    .then((res) => Promise.resolve(res))
    .catch((e) => Promise.reject(e));
};

const BasicAccountApplicationAPI = {
  create,
  createGeneralCompanyInformation,
  createPowerOfAttorney,
  query,
  updateCompanyInformation,
  updateCompanyOnline,
  updateRegulatoryInfo,
  requestBasicAccountBenefits,
  cancel,
  changeProduct,
  retrieveImageServiceLink,
};

export default BasicAccountApplicationAPI;
